/*eslint-disable*/
import React from "react";
import tt from "../../assets/img/tt.png"

// reactstrap components
import { Container, Row, Col, Button } from "reactstrap";

// core components

function FooterBlack() {
  return (
    <>
      <footer className="footer footer-black footer-white">
      <Container>
          <Row>
            <nav className="footer-nav">
              <ul>
                <li>
                  <a
                    href="/"
                    className="mr-1"
                  >
BEACH TOURS CARTAGENA                  </a>
                </li>
                {/* <li>
                  <a
                    href="/about-us"
                    className="mr-1"
                  >
                    About Us
                  </a>
                </li>
                <li>
                  <a
                    href="https://checkout.wompi.co/l/JXJM61://www.creative-tim.com/license?ref=pkpr-white-footer"
                  >
                    Payments
                  </a>
                </li> */}
              <Row>  <li>
                <Col md="3" xs="3">
                  <div className="social-area">
                    <Button
                      className="btn-just-icon btn-round mr-1"
                      color="dribble"
                      href="https://www.tiktok.com/@btcartagenaonline"
                    >
                                       <center>  <img src={tt} style={{height:"24px"}} /></center>

                    </Button>
                   
                  
                
                  </div>
                </Col></li>
                  <li>
                <Col md="3" xs="3">
                  <div className="social-area">
                    <Button
                      className="btn-just-icon btn-round mr-1"
                      color="facebook"
                      href="https://facebook.com"
                    >
                      <i className="fa fa-facebook" />
                    </Button>
                   
                  
                
                  </div>
                </Col></li>
                <li>
                <Col md="3" xs="3">
                  <div className="social-area">
                  <Button
                      className="btn-just-icon btn-round mr-1"
                      color="google"
                      href='https://www.instagram.com/btcartagenaonline/'
                    >
                      <i className="fa fa-instagram" />
                    </Button>
                   
                  
                
                  </div>
                </Col></li>

                </Row>
              </ul>
          
            </nav>
            <div className="credits ml-auto">

              <span className="copyright" href="https://makeyourtime.store">
                © {new Date().getFullYear()}
                , made with <i className="fa fa-heart heart" /> by DC7
              </span>
            </div>
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default FooterBlack;
